import { useMediaQuery } from "@mui/material";
import he from "he";
import { Socials } from "../../components";
import { ReactComponent as Logo } from "../../assets/white_logo.svg";
import { ReactComponent as SearchIcon } from "../../assets/search.svg";
import style from "./style.module.scss";

function ScrollMenu({ home, socials, categories, categoriesLink }) {
  const isLaptop = useMediaQuery(`(max-width: ${style.desktopBreakpoint})`);

  const focusSearchBar = () => {
    window.scrollTo(0, 0);
    document.getElementById("searchBarHeader").focus();
  };

  return (
    <div className={style.scrollMenu}>
      <div className={style.content}>
        <div className={style.left}>
          <a href={home}>
            <Logo className={style.logo} />
          </a>

          {categories &&
            Object.values(categories).map((category) => (
              <a key={category.cat_ID} href={category.url}>
                {he.decode(category.name)}
              </a>
            ))}
        </div>

        <div className={style.right}>
          {categoriesLink && (
            <a href={categoriesLink.url}>{categoriesLink.label}</a>
          )}

          <SearchIcon className={style.searchIcon} onClick={focusSearchBar} />

          {!isLaptop && <Socials socials={socials} />}
        </div>
      </div>
    </div>
  );
}

export default ScrollMenu;
